<template>
    <v-dialog v-model="showDialog" fullscreen hide-overlay transition="dialog-bottom-transition" @keydown.esc="tryCancelEditScout">
        <v-card class="scouting-add-edit-dialog-card">
            <v-toolbar dark color="primary">
                <v-btn icon dark :disabled="saving" @click="tryCancelEditScout">
                    <v-icon large>close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>

                <v-toolbar-title>{{editedPlantObject.PlantName}} / {{editedDivisionObject.DivisionName}} / {{editedLocationObject.LocationName}}</v-toolbar-title>

                <v-spacer></v-spacer>
                <v-toolbar-items>
                </v-toolbar-items>
            </v-toolbar>
            <v-form ref="editForm" v-model="editScoutValid">
                <v-layout wrap class="dialog-content">
                    <v-flex xs12>
                        <v-layout v-if="showStage === 1" wrap class="dialog-action-buttons dialog-action-buttons-fixed">
                            <v-flex xs12 sm6 md3 offset-md3>
                                <v-btn block color="error" @click="tryChangeSelectedSpotCheck()">Cancel Spot Check</v-btn>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-btn block color="success" @click="saveSpotCheck">Save Spot Check</v-btn>
                            </v-flex>
                        </v-layout>
                        <v-layout v-if="showStage === 1" wrap class="dialog-action-buttons">
                            <!-- <v-flex xs12 sm4>
                                <v-btn block color="error" :disabled="saving" @click="tryCancelEditScout">Cancel</v-btn>
                            </v-flex> -->
                            <v-flex xs12 sm6 md3 offset-md3>
                                <v-btn block color="success" :loading="saving" @click="saveScoutAndCloseDialog(false)">Save Progress</v-btn>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-btn block color="success" :loading="saving" @click="moveToClosingPage">Close Location</v-btn>
                            </v-flex>
                        </v-layout>
                        <v-layout v-if="showStage === 2" wrap class="dialog-action-buttons">
                            <v-flex xs12 sm6 md3 offset-md3>
                                <v-btn block color="error" :loading="saving" @click="moveToSpotCheckEntry">Go Back</v-btn>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-btn block color="success" :loading="saving" :disabled="!editScoutValid" @click="saveScoutAndCloseDialog(true)">Save and Close</v-btn>
                            </v-flex>
                        </v-layout>
                        
                        <v-layout wrap>
                            <v-flex xs12 sm6 offset-sm3 class="text-xs-center">
                                <v-menu
                                    v-model="dateMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            :value="editedScouting.Date | formatDate"
                                            label="Date"
                                            prepend-icon="event"
                                            readonly
                                            v-on="on">
                                        </v-text-field>
                                    </template>
                                    <v-date-picker :value="formatDate(editedScouting.Date)" @input="updateEditedDate" ></v-date-picker>                                                                    
                                </v-menu>
                            </v-flex>
                            <v-flex v-if="saveErrorMessage" xs12 sm6 offset-sm3 class="text-xs-center">
                                <v-alert :value="true" color="error" outline icon="error">
                                    {{saveErrorMessage}}
                                </v-alert>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap v-if="showStage === 1">
                            <v-flex class="text-xs-center spot-check-button-container">
                                <v-btn v-for="index in totalSpotChecks" :key="index" large :color="spotCheckButtonColour(index)" @click="tryChangeSelectedSpotCheck(index)">
                                    {{ index }}
                                </v-btn>
                                <v-btn large color="info" @click="addNewSpotCheck()">
                                    Add New
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12>
                                    <v-alert :value="saveError"
                                        outline
                                        type="error">
                                        {{saveError}}
                                </v-alert>
                            </v-flex>
                        </v-layout>

                        <v-layout wrap v-show="showStage === 1">
                            <v-flex xs12 v-for="index in totalSpotChecks" :key="index">
                                <ScoutingSpotCheckEditor
                                    v-if="selectedSpotCheckNumber === index"
                                    :initialData="spotCheck(index) || createNewSpotCheck(index)"
                                    :editedScouting=editedScouting
                                    @onSave="savingSpotCheck($event)"
                                    @onUnsavedChanges="unsavedChangesSpotCheck"
                                    @onCheckUnsaved="completeChangeSelectedSpotCheck">
                                </ScoutingSpotCheckEditor>
                            </v-flex>
                        </v-layout>

                        <v-layout wrap v-if="showStage === 2">
                            <v-flex xs12 md6 offset-md3 class="text-xs-center">
                                <v-autocomplete                                
                                    label="Crop Stage"
                                    :items="cropStages"
                                    item-value="ScoutingCropStageID"
                                    item-text="Name"
                                    v-model="editedScouting.ScoutingCropStageID"                                    
                                    hide-details
                                    clearable
                                    dense
                                    >
                                </v-autocomplete>
                            </v-flex>
                            <v-flex xs12 md6 offset-md3 class="text-xs-center">
                                <v-checkbox
                                    label="Fruit Left on Plants"
                                    class="checkbox-inline-block"
                                    v-model="editedScouting.FruitOnPlants"
                                    hide-details
                                ></v-checkbox>
                            </v-flex>
                            <v-flex xs12 md6 offset-md3>
                                <v-textarea
                                    v-model="editedScouting.Notes"
                                    :rules="[requiredWhenLessThanOneSpotChecks]"
                                    label="Notes">
                                </v-textarea>
                            </v-flex>
                            <v-flex xs12 md6 offset-md3>
                              <v-card>
                                <v-card-title primary-title>
                                  <div>
                                    <h3 class="headline mb-0">Scouting Summary</h3>
                                  </div>
                                </v-card-title>
                                <v-card-text>
                                  <ScoutingSummary
                                      :editedScouting="editedScouting">
                                  </ScoutingSummary>
                                </v-card-text>
                              </v-card>
                            </v-flex>
                        </v-layout>

                    </v-flex>
                </v-layout>
            </v-form>
        </v-card>

        <ConfirmUnsavedChangesPopup
            :display="showConfirmDialogSpotCheck"
            :dialogContents="'Are you sure you wish to cancel? Any unsaved changes will be lost.'"
            :title="'Unsaved Spot Check Changes'"
            @Cancel="showConfirmDialogSpotCheck = false"
            @Continue="changeSelectedSpotCheck()" />

        <ConfirmUnsavedChangesPopup
            :display="showConfirmDialogScouting"
            :dialogContents="'Are you sure you wish to cancel? Any unsaved changes will be lost.'"
            :title="'Unsaved Scouting Changes'"
            @Cancel="showConfirmDialogScouting = false"
            @Continue="cancelEditScout()" />
    </v-dialog>
</template>

<script>
import ScoutingSpotCheckEditor from "@/components/scout/ScoutingSpotCheckEditor.vue";
import ConfirmUnsavedChangesPopup from "@/components/scout/ConfirmUnsavedChangesPopup.vue";
import ScoutingSummary from "@/components/scout/ScoutingSummary.vue";

import validationRules from "@/helpers/validationrules";
import UtilService from "@/services/utilService.js";

import moment from "moment";

export default {
    data() {
        return {
            debug: false,

            showDialog: false,
            showConfirmDialogSpotCheck: false,
            confirmDialogNewNumber: null,
            showConfirmDialogScouting: false,

            saveErrorMessage: null,

            likelyUnsavedChangesInSpotCheck: false,

            nextSaveIsExit: false,
            moveToClosingPageAfterSave: false,
            
            showStage: 1, // stage 1 is editing spot checks, stage 2 is when we are closing the location and entering a note

            editedScouting: {},

            dateMenu: false,

            selectedSpotCheckNumber: 1,

            rules: validationRules.rules,
            saving: false,
            editScoutValid: false,
            
            saveError: null,
            initialSpotCheckCount: 5
        }
    },
    props: [
        "initialData"
    ],
    components: {
        ScoutingSpotCheckEditor,
        ConfirmUnsavedChangesPopup,
        ScoutingSummary
    },
    watch: {
        // editedScouting: {
        //     handler(newVal) {
        //         if (this.debug) console.log(`this.editedScouting changed to:`, JSON.stringify(newVal));
        //     },
        //     deep: true
        // }
    },
    computed: {
        selectedPlant: {
            get() {
                return this.$store.state.PestAndDiseaseStore.selectedPlant;
            }
        },
        selectedDivision: {
            get() {
                return this.$store.state.PestAndDiseaseStore.selectedDivision;
            }
        },
        selectedLocation: {
            get() {
                return this.$store.state.PestAndDiseaseStore.selectedLocation;
            }
        },
        totalSpotChecks: {
            get() {
                return this.editedScouting.SpotChecks;
            }
        },
        selectedPlantObject() {
            return this.$store.getters["PestAndDiseaseStore/getSelectedPlantObject"];
        },
        selectedDivisionObject() {
            return this.$store.getters["PestAndDiseaseStore/getSelectedDivisionObject"];
        },
        selectedLocationObject() {
            return this.$store.getters["PestAndDiseaseStore/getSelectedLocationObject"];
        },
        editedLocationObject() {
            if (this.editedScouting.LocationID) {
                return this.$store.getters["PestAndDiseaseStore/getLocationByID"](this.editedScouting.LocationID);
            }
            
            return {};
        },
        editedDivisionObject() {
            if (this.editedScouting.LocationID) {
                return this.$store.getters["PestAndDiseaseStore/getDivisionByID"](this.editedLocationObject.Division.DivisionID);
            }
            
            return {};
        },
        editedPlantObject() {
            if (this.editedScouting.LocationID) {
                return this.$store.getters["PestAndDiseaseStore/getPlantByID"](this.editedDivisionObject.Plant.PlantID);
            }
            
            return {};
        },
        cropStages() {
            return this.$store.getters["ScoutStore/getScoutingCropStages"].filter(s => s.IsActive);
        }
    },
    methods: {
        addNewSpotCheck() {
            this.editedScouting.SpotChecks += 1;
            this.selectedSpotCheckNumber =  this.editedScouting.SpotChecks;
        },
        spotCheck(number) {
            let data = this.editedScouting.ScoutingSpotChecks.find(sc => sc.Number == number);

            return data;
        },
        createNewSpotCheck(number) {
            return {
                ScoutingSpotCheckID: -1,
                ScoutingID: this.editedScouting.ScoutingID,
                Number: number,
                ScoutingSpotCheckObservations: []
            };
        },
        spotCheckButtonColour(number) {
            if (this.selectedSpotCheckNumber === number) {
                return "accent"
            }
            else if (this.editedScouting && this.editedScouting.ScoutingSpotChecks) {
                let spotCheck = this.spotCheck(number);

                if (spotCheck) {
                    return "success";
                }
            }

            return "error";
        },

        requiredWhenLessThanOneSpotChecks(value) {
            if (this.editedScouting.ScoutingSpotChecks && this.editedScouting.ScoutingSpotChecks.length >= 1) {
                // not required to enter any value for notes when there are less than 5 spot checks entered
                return true;
            }
            else {
                if (!UtilService.stringIsBlank(value)) {
                    // as long as there is something in notes then we are ok
                    return true;
                }
            }

            return "Required when less than 1 spot check";
        },

        tryChangeSelectedSpotCheck(number) {
            // assume the current number if none specified
            let newNumber = number || this.selectedSpotCheckNumber;

            // if nothing currently selected, no fancy checking for unsaved changes required, just change the selection
            if (!this.selectedSpotCheckNumber) {
                this.selectedSpotCheckNumber = newNumber;
            }
            else {
                this.$root.$emit("tryChangeSelectedSpotCheck", {currentlySelectedNumber: this.selectedSpotCheckNumber, newNumber: newNumber});
            }
        },
        completeChangeSelectedSpotCheck(data) {
            if (data.unsavedChanges) {
                // if there are unsaved changes, then we need to confirm that the user wants to lose them
                this.confirmDialogNewNumber = data.newNumber;
                this.showConfirmDialogSpotCheck = true;
            }
            else {
                // if there are no unsaved changes, then we can carry on with the navigation to somewhere else
                this.changeSelectedSpotCheck(data.newNumber)
            }
        },
        changeSelectedSpotCheck(newNumber) {
            // either passed in as argument, or available in data
            let actualNewNumber = newNumber || this.confirmDialogNewNumber;

            // first cancel any pending changes to the currently selected spot check
            // (we should have confirmed this before getting to this point)
            this.cancelEditSpotCheck();

            // let newIndex = data.number - 1;

            if (this.selectedSpotCheckNumber === actualNewNumber) {
                // we've clicked on the button for the currently displayed spot check - hide it
                // this.hideSpotCheckEditor();

                // we've clicked on the button for the currently displayed spot check - do nothing)
            }
            else {
                this.selectedSpotCheckNumber = actualNewNumber;
            }

            this.confirmDialogNewNumber = null;
            this.showConfirmDialogSpotCheck = false;
        },

        unsavedChangesSpotCheck() {
            // this is only "likely" because we might change them back later
            // this is just a guide to make sure we show a confirmation prompt when attempting to leave this dialog
            this.likelyUnsavedChangesInSpotCheck = true;
        },
        tryCancelEditScout() {
            if (JSON.stringify(this.initialData) != JSON.stringify(this.editedScouting) || this.likelyUnsavedChangesInSpotCheck) {
                // we have made changes since the control was initialised
                // (or we might have made changes - we don't track each spot check 100%, we just set a flag whenever something changes, so we're aggressive with showing this confirmation popup)
                this.showConfirmDialogScouting = true;
            }
            else {
                this.cancelEditScout();
            }
        },
        cancelEditScout() {
            // the parent component can handle the hiding of the dialog, and whatever else it wants to do
            this.$emit("cancelAddEditScout");

            this.showConfirmDialogScouting = false;
        },

        moveToSpotCheckEntry() {
            this.showStage = 1;
        },
        moveToClosingPage() {
            this.saveSpotCheck({moveToClosingPageAfterSave: true});
        },
        async saveScoutAndCloseDialog(closeLocation) {
            this.editedScouting.Closed = closeLocation;

            // before we close the dialog, we need to make sure any edits to the currently displayed spot check are saved
            this.saveSpotCheck({exitDialogAfterSave: true});
        },

        // hideSpotCheckEditor() {
        //     this.selectedSpotCheckNumber = undefined;
        // },
        cancelEditSpotCheck() {
            this.$root.$emit("cancelScoutingSpotCheck", this.selectedSpotCheckNumber);

            this.likelyUnsavedChangesInSpotCheck = false;
        },
        saveSpotCheck(options) {
            this.nextSaveIsExit = options ? (!!options.exitDialogAfterSave) : false;
            this.moveToClosingPageAfterSave = options ? (!!options.moveToClosingPageAfterSave) : false;

            // we need to fish the latest data out of the child component, somehow
            // we could use a store for this, but instead we are going to send a message to the component via the global event bus
            // this message is being listed to by the child component, which will emit it's own event, passing the appropriate data back up to the current component
            this.$root.$emit("saveScoutingSpotCheck", this.selectedSpotCheckNumber);
        },
        async savingSpotCheck(spotCheckEdited) {
            // spotCheck contains the data from the child component - we need to replace our data with this

            // this copy should help us ensure that we do not accidentally start changing data referenced in the child/parent from the wrong place
            let spotCheck = JSON.parse(JSON.stringify(spotCheckEdited));

            // set the time that this was saved
            spotCheck.TimeSaved = UtilService.formatDateYMDHMS(moment.utc());

            // first find the original data, if there is any
            let index = this.editedScouting.ScoutingSpotChecks.findIndex(sc => sc.Number === spotCheck.Number);

            // now add to or overwrite in the original
            if (index < 0) {
                this.editedScouting.ScoutingSpotChecks.push(spotCheck);
            }
            else {
                this.editedScouting.ScoutingSpotChecks.splice(index, 1, spotCheck);
            }

            if (this.nextSaveIsExit) {
                // we are going to continue with saving the actual scouting object, and close the dialog
                await this.saveScout();

                this.nextSaveIsExit = false;
            }
            else if (this.moveToClosingPageAfterSave) {
                // we are going to move to stage 2 of the edit dialog, where we are presented with further input fields
                this.showStage = 2;

                this.$refs.editForm.validate();

                this.moveToClosingPageAfterSave = false;
            }
            else {
                // after we have saved, move to the next spot check
                this.selectedSpotCheckNumber = Math.min(this.selectedSpotCheckNumber + 1, this.totalSpotChecks);

                this.$refs.editForm.validate();
            }
        },

        async saveScout() {
            // always clear any previous error message before continuing
            this.saveErrorMessage = null;

            this.saving = true;

            // we need to check for any duplicate records - these will cause issues
            let existingRecords = this.$store.getters["ScoutStore/getExistingScoutingsForDateAndLocation"](this.editedScouting.Date, this.editedScouting.LocationID, this.editedScouting.CreatedBy);

            let newScouting = false;
            if (!this.editedScouting.ScoutingID || this.editedScouting.ScoutingID <= 0) {
                newScouting = true;
            }

            if (newScouting && existingRecords && existingRecords.length > 0) {
                // show a message indicating that we cannot save records with duplicate data
                this.saveErrorMessage = "There is already an existing scout record for the selected location, date and user";
            }
            else {
                // if we're all good, then actually save the scouting data

                await this.$store.dispatch("ScoutStore/saveScout", { scouting: this.editedScouting, plantIDs: [this.selectedPlant] });

                this.cancelEditScout();
            }

            this.saving = false;
        },

        formatDate(v) {
            if (v) {
                return UtilService.formatDateYMD(v);
            }
            
            return null;
        },
        updateEditedDate(newVal) {
            this.editedScouting.Date = newVal;
            this.dateMenu = false;
        },
    },
    async created() {
        // when this component is created, it has some initial data in an object (in the initialData prop)
        // this initial data might have come from, for example, a Vuex store
        // if it has, we do *not* want to mutate this object, because it might change what is in the store, or other places
        // hence we take a copy of it to use locally

        this.editedScouting = JSON.parse(JSON.stringify(this.initialData));

        // now our initial view should be on the latest unsaved spot check
        if (this.editedScouting.ScoutingSpotChecks) {
            for (let index = 1; index < this.totalSpotChecks + 1; index++) {
                if (this.editedScouting && this.editedScouting.ScoutingSpotChecks) {
                    let spotCheck = this.spotCheck(index);

                    if (!spotCheck) {
                        this.selectedSpotCheckNumber = index;
                        break;
                    }
                }
            }
        }
    },
    async mounted() {
        // doing this in mounted (rather than created) means the dialog animation is shown
        this.showDialog = true;
    }
}
</script>

<style>
/* make the spot check buttons bigger */
.spot-check-button-container .v-btn {
    padding-left: 50px;
    padding-right: 50px;
    font-weight: bold;
    font-size: 20px;
}

/* spot check button text colour changed when selected */
.spot-check-button-container .v-btn--active .v-btn__content {
    color: white;
}

.dialog-action-buttons-fixed {
    position: fixed;
    left: 0px;
    bottom: 0px;
    width: 100%;
    z-index: 10;
    background-color: white;
}

/* this allows the checkbox to be centered (using text-xs-center elsewhere) */
.checkbox-inline-block {
    display: inline-block;
}

/* leave some space at the bottom for the buttons fixed to the bottom of the screen */
.scouting-add-edit-dialog-card .dialog-content {
    padding-bottom: 50px;
}
</style>
